module.exports = __webpack_public_path__ + "assets/img/green.7fb24564.png";